module.exports = __webpack_public_path__ + "img/search-button.fbe63f59.png";